

function ATC_Click(pid) {
    //document.querySelector('button[data-atc="' + pid + '"]').click();
    document.querySelector('button[data-slidecart-button="' + pid + '"]').click();
}

function ShowVariantPrice(product) {
    let product_id = product.getAttribute('data-product');
    let selected_ption = product.options[product.selectedIndex];
    let price = selected_ption.getAttribute('data-price');

    document.querySelector('[data-product-price="' + product_id + '"]').innerHTML = price;
    //document.querySelector('[data-atc="' + product_id + '"]').setAttribute('data-variant-id', product.value);
    document.querySelector('[data-slidecart-id="' + product_id + '"]').value = product.value;
}

function FreeShippingCheck(total_price) {
    document.querySelector('.go-cart-drawer__shipping').style.display = 'block';

    if (dynamic_free_shipping) {
        var cart_price = total_price / 100;

        if (cart_price > free_shipping_minimum) {
            document.querySelector('.go-cart-drawer__shipping div').classList.add('free-shipping');
            document.querySelector('.go-cart-drawer__shipping div').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> ' + dynamic_free_shipping_success;
        }
        else {
            var amount_to_free_shipping = free_shipping_minimum - cart_price;
            document.querySelector('.go-cart-drawer__shipping div').classList.remove('free-shipping');
            document.querySelector('.go-cart-drawer__shipping div').innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> $' + amount_to_free_shipping.toFixed(2) + ' ' + dynamic_free_shipping_alert; 
        }
    }
    else {
        document.querySelector('.go-cart-drawer__shipping div').classList.add('free-shipping');
        document.querySelector('.go-cart-drawer__shipping div').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> ' + static_free_shipping_message;
    }
}

function RecoChangePrice(obj) {
    let variant_price = obj.options[obj.selectedIndex].getAttribute('data-price');
    obj.parentElement.parentElement.querySelector('.go-cart-drawer__upsell-product-price').innerHTML = variant_price;
}

if (document.querySelector('#pv_postcode_text')) {
    document.querySelector('#pv_postcode_text').addEventListener("keypress", function(e) {
        if (e.keyCode == 13 || e.which == 13) {
            e.preventDefault();

            document.querySelector('#pv_postcode_submit').click();
        }
    });
}

function RecoProductsUpsell(products) {
    document.querySelector('.go-cart-drawer__upsell').style.display = 'none';
    document.querySelector('.go-cart-drawer__reco').style.display = 'none';

    setTimeout(function() {
        for (let x = 0 ; x < 5 ; x++) {
            if (x < products.length) {
                let index = x + 1;
                document.querySelector('.go-cart-drawer__reco .reco-product-' + index).style.display = 'flex';

                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' .go-cart-drawer__upsell-product-img').innerHTML = '<img src="' + products[x].featured_image + '" alt="" style="width: 100px;">';
                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' .go-cart-drawer__upsell-product-title').innerHTML = '<a href="' + products[x].url + '">' + products[x].title + '</a>';
                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' .go-cart-drawer__upsell-product-price').innerHTML = '$' + (products[x].variants[0].price / 100).toFixed(2);
                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' select').innerHTML = '';

                let variant_options = '';
                products[x].variants.forEach(function(variant) {
                    variant_options += '<option value="' + variant.id + '" data-price="' + ('$' + (variant.price / 100).toFixed(2)) + '">' + variant.title + '</option>';
                });

                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' select').innerHTML = variant_options;

                if (products[x].variants.length == 1 && products[x].variants[0].title == "Default Title") {
                    document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' select').style.display = 'none';
                }
                else {
                    document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' select').style.display = 'block';
                }

                document.querySelector('.go-cart-drawer__reco .reco-product-' + index + ' #reco_url').value = products[x].url;
            }
            else {
                document.querySelector('.go-cart-drawer__reco .reco-product-' + index).style.display = 'none';
            }
        }

        document.querySelector('.go-cart-drawer__upsell').style.display = 'none';
        document.querySelector('.go-cart-drawer__reco').style.display = 'block';
        document.querySelector('.go-cart-drawer__reco .go-cart-drawer__upsell-products').scrollLeft = 0;
    }, 500);
}

function RecoPageLoad(obj) {
    let reco_url = obj.parentElement.querySelector('#reco_url').value;
    console.log(reco_url);
    $.ajax({
        url: reco_url, 
        method: 'GET',
        success: function(result){ 
            obj.parentElement.querySelector('button[type="submit"]').click();       
        }
    });
}

$("#postcode-form").on("submit", (function(e) {
    console.log(11);
    e.preventDefault();
    var t = "https://shopifyapps.concise.digital/postcode_validator/cart_response.php?shop_url=food-for-reasons.myshopify.com&postcode=" + $("#input-postcode").val();
    $.get(t, (function(e, t) {
        var i = e.split("|")[0];
        var a = e.split("|")[e.split("|").length - 1];
        document.querySelector(".modal-content").style.margin = "10% auto", "Valid" == i ? ($(".postcode-result").show(), $(".postcode-result .postcode-success").show(), $(".postcode-result .postcode-failed").hide(), $(".postcode-result .message").html(a)) : ($(".postcode-result").show(), $(".postcode-result .postcode-success").hide(), $(".postcode-result .postcode-failed").show(), $(".postcode-result .message").html(a))
    }))
}));

$(document).ready(function() {
    setTimeout(function() {
    if (typeof window.StoreCredit !== 'undefined') {
        if (window.StoreCredit.customerCredit > 0) {
          if ($('#cart-available-credits').length) {
            $('#cart-available-credits').css('display', 'block');
            $('#cart-available-credits').html('You have an available credit of $' + window.StoreCredit.customerCredit + '.');
          }
        }
    }
    }, 2000);

    $(".checkout-dummy").click(function(e) {
        e.preventDefault();
        // console.log("dummy button clicked");
        // console.log($(this).attr('data-shipping'));

        if( $(this).attr('data-shipping') != "false" ) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'attributes[Postcode]=' + jQuery('#pv_postcode_text').val() + '&attributes[Delivery-Date]=' + jQuery('#delivery-date').val() + '&attributes[Delivery-Date-Request-Time]=' + jQuery('#delivery-date-request-time').val() + '&note=' + jQuery("#cart-note").val() + '&attributes[Out-Of-Stock-Preference]=' + jQuery("#oos-preference").val(),
                dataType: 'text',
                success: function(responseData, textStatus, jqXHR) {
                    // console.log('updated cart');
                },
                error: function (responseData, textStatus, errorThrown) {
                //   console.log(errorThrown);
                }
            });
        }

        if( $(".cart-pvc-sidebar__oos-preference summary").attr("data-oos-option") !== "0" ) {
            if( $("button[name='creditsyard-checkout']").length ) {
                $("button[name='creditsyard-checkout']").click();
                // console.log("Credits button clicked");
            } else if( $("button[name='checkout']").length ) {
                $("button[name='checkout']").click();
                // console.log("Default checkout button clicked");
            }
        } else {
            $('.outOfStock-error-message').show()
        }
    });
    
    jQuery( document ).on('click', '#delivery-date', function() {
      $("#delivery-date-inline").toggleClass("show");
    });
    
    let quantityButton = $(".quantity__button");

    quantityButton.click(function(e) {
        e.preventDefault();
        
        let quantityField = $(this).siblings(".form-field-input[data-quantity-input]");
        let quantityValue = parseInt(quantityField.val(), 10);

        let buttonFunc = $(this).attr("name");
        if( buttonFunc === "plus" && quantityValue >= 1 ) {
            quantityField.val( quantityValue + 1 )
        } else if( buttonFunc === "minus" && quantityValue > 0 ) {
            quantityField.val( quantityValue - 1 )
        } else {
            return;
        }
    });

    $("#cart-note").change(function() {
        if( $(this).val() ) {
            $(".cart-pvc-sidebar__order-note").addClass("cart-pvc-sidebar__success");
        } else if( $(this).val() === "" && $(".cart-pvc-sidebar__order-note").hasClass("cart-pvc-sidebar__success") ) {
            $(".cart-pvc-sidebar__order-note").removeClass("cart-pvc-sidebar__success");
        }
    });
});
